module.exports = __webpack_public_path__ + "static/media/hazard_icon.0c9498fb.svg";